import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {HttpService} from "src/app/share-modul/services/common/http-service";
import {environment} from "../../../../environments/environment";
import {map} from "rxjs";
import {RemoveEmployeeFromVenueModel} from "../../models/employees/remove-employee-from-venue.model";
import {AddOrEditEmployeeLogModel} from "../../models/employees/add-or-edit-employee-log.model";
import {AddOrEditEmployeeModel} from "../../models/employees/add-or-edit-employee.model";

const EMPLOYEES_API = environment.apiURL + '/api/mng/Employee/';

@Injectable({
  providedIn: 'root'
})
export class ManagerEmployeeService {
  //#region Fields
  //#endregion

  //#region Constructor
  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }

  //#endregion

  //#region Public Methods
  listAllEmployeesForVenue(venueId: string, date: string) {
    let url = EMPLOYEES_API + "listallemployeesforvenue?VenueId=" + venueId + "&SelectedDate=" + date;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  listallwaitersforvenue(venueId:string){
    let url = EMPLOYEES_API + "listallwaitersforvenue?VenueId=" + venueId;
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }))
  }

  removeEmployeeFromVenues(model: RemoveEmployeeFromVenueModel) {
    let url = EMPLOYEES_API + 'employeeremovefromvenue';
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  removeEmployeeLog(logId: string) {
    let url = EMPLOYEES_API + 'removeemployeelog';
    return this._httpService.httpPost(url, '"' + logId + '"')
      .pipe(map(response => {
        return response;
      }));
  }

  addEmployeeLog(logId: AddOrEditEmployeeLogModel) {
    let url = EMPLOYEES_API + 'addemployeelog';
    return this._httpService.httpPost(url, logId)
      .pipe(map(response => {
        return response;
      }));
  }

  updateEmployeeLog(logId: AddOrEditEmployeeLogModel) {
    let url = EMPLOYEES_API + 'updateemployeelog';
    return this._httpService.httpPost(url, logId)
      .pipe(map(response => {
        return response;
      }));
  }

  generateNewPin() {
    let url = EMPLOYEES_API + "getnewpin";
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response.toString();
      }));
  }

  updateEmployee(model: AddOrEditEmployeeModel, filePicture: any) {
    let url = EMPLOYEES_API + "updateemployee";
    let formData: FormData = new FormData();
    formData.append('Id', model.id)
    formData.append('FirstName', model.firstName)
    formData.append('LastName', model.lastName)
    formData.append('Email', model.email)
    formData.append('Address', model.address)
    formData.append('Phone', model.phone)
    formData.append('EmployeeTypeId', model.venueEmployeeTypeId.toString())
    formData.append('Pin', model.pin)
    formData.append('ImageFile', filePicture as string)
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  logoutEmployee(id: string) {
    let url = EMPLOYEES_API + "remotelogoutemployee?EmployeeId=" + id;
    return this._httpService.httpPost(url)
      .pipe(map(response => {
        return response.toString();
      }));
  }
  //#endregion
}
